import Content from "uxp-documentation/src/pages/uxp-api/reference-html/Hierarchy/hr";
import * as React from 'react';
export default {
  Content,
  React
};